import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

import CloseButton from '../../../../commons/src/components/close-button'

export interface Props {
  classNames?: string[]
  header?: React.ReactNode
  footer?: React.ReactNode
  title?: React.ReactNode
  children: React.ReactNode
  scrollContainerRef?: React.RefObject<HTMLDivElement>
  onClose?: React.MouseEventHandler
}

// TODO move this commons package once ccds is integrated into craftcloud
const Sidebar = ({
  classNames,
  header,
  footer,
  children,
  title,
  scrollContainerRef,
  onClose,
}: Props) => (
  <div className={cn('Sidebar', {}, classNames)}>
    {header && <div className="Sidebar__header">{header}</div>}
    <div className="Sidebar__main" ref={scrollContainerRef}>
      {title && (
        <div className="Sidebar__titleHeader">
          <div className="Sidebar__title">{title}</div>
          {onClose && (
            <div className="Sidebar__close">
              <CloseButton onClick={onClose} />
            </div>
          )}
        </div>
      )}
      <div className="Sidebar__children">{children}</div>
    </div>
    {footer && <div className="Sidebar__footer">{footer}</div>}
  </div>
)

export default Sidebar
